export const MIN_TIME = '00:00:00'
export const MAX_TIME = '23:59:59'

export const ELEMENTS_TO_DISPLAY = {
	RESSOURCES: 'RESSOURCES',
	TOOLS: 'TOOLS'
}

// Préfixe de clé localStorage pour la persistance des filtres du scheduler (suffixé par l'id de ferme)
export const SCHEDULER_FILTERS_STORAGE_KEY_PREFIX = 'permasoft.scheduler.filters'